export const SET_IS_LOADING = 'SET_IS_LOADING/PROMOTION'
export const SET_PAGINATION_DATA_PROMOTION = 'SET_PAGINATION_DATA_PROMOTION/PROMOTION'
export const SET_PROMOTION_DATA = 'SET_PROMOTION_DATA/PROMOTION'
export const SET_LAST_QUERY = 'SET_LAST_QUERY/PROMOTION'
